module.exports = __webpack_public_path__ + "img/login-3.7e41c71d.png";